import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Receipt, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { API, errorText } from "@/lib/payments";
import { QuotationForm } from "@/components/admin/QuotationForm";
import { QuotationCard } from "@/components/admin/QuotationCard";

export const QuotationsTab = ({ authHeader, prefillInquiry, onPrefillConsumed }) => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/quotations`, { headers: authHeader() });
      setQuotes(res.data);
    } catch (err) {
      toast.error(errorText(err, "Could not load quotations"));
    } finally {
      setLoading(false);
    }
  }, [authHeader]);

  useEffect(() => { load(); }, [load]);

  const replace = (q) => setQuotes((prev) => prev.map((x) => (x.id === q.id ? q : x)));
  const closeForm = (o) => { setFormOpen(o); if (!o && prefillInquiry) onPrefillConsumed(); };

  return (
    <div className="space-y-4" data-testid="quotations-tab">
      <div className="flex items-center justify-between">
        <p className="text-sm text-stone-500">Create a draft, approve it to lock the amount, then copy the payment link to WhatsApp or email.</p>
        <Button onClick={() => setFormOpen(true)} data-testid="new-quotation-btn"><Plus className="h-4 w-4 mr-1" />New quotation</Button>
      </div>
      {loading ? (
        <div className="text-center py-12"><Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" /></div>
      ) : quotes.length === 0 ? (
        <Card><CardContent className="py-12 text-center">
          <Receipt className="h-12 w-12 text-stone-300 mx-auto mb-4" />
          <p className="text-stone-500" data-testid="quotations-empty">No quotations yet</p>
        </CardContent></Card>
      ) : (
        quotes.map((q) => <QuotationCard key={q.id} q={q} authHeader={authHeader} onChange={replace} />)
      )}
      <QuotationForm key={prefillInquiry?.id || "new"} open={formOpen || !!prefillInquiry} onOpenChange={closeForm} authHeader={authHeader} inquiry={prefillInquiry}
        onCreated={(q) => setQuotes((prev) => [q, ...prev])} />
    </div>
  );
};
